import React from 'react';
import { MentionsInput, Mention } from 'react-mentions';
import UrlPreview from '../Utils/UrlPreview';

export default class PostPreviewUrl extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            parseUrlData: []
        };

        this.onUrlLoaded = this.onUrlLoaded.bind(this);
        this.getUrls = this.getUrls.bind(this);
    }

    onUrlLoaded() {
        this.setState({ ...this.state, parseUrlData:[]});


        setTimeout(() => {
            const urlItem = []
            const parseUrlData = [];
            if (this.props.parseUrlAsync) {
                const parsedUrls = this.getUrls(this.props.value);
                if (parsedUrls && parsedUrls.length > 0) {
                    parsedUrls.map((item,index) =>{
                        urlItem.push({})
                        this.setState({
                            parseUrlData:urlItem
                        },() => {
                            this.props.parseUrlAsync(item).then(result => {
                                parseUrlData[index] = result.body
                                this.setState({
                                    parseUrlData:parseUrlData
                                });
                            });
                        })
                    })
                }
            }
        }, 200)
    }

    getUrls(body) {
        const urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g;

        const links = body.match(urlRegex, function(url) {
            return url;
        })

        return links;
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.value !== this.props?.value){
            this.onUrlLoaded()
        }
    }

    componentDidMount() {
        this.onUrlLoaded();
    }

    render() {
        return (
            <>
            {this.state.parseUrlData && this.state.parseUrlData.length > 0 && this.state.parseUrlData.map((item, index) => (
                    <UrlPreview {...item} key={index + item.title} />
                ))}
            </>
        );
    }
}
